import type { FC } from 'react';
import { Trans } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { ErrorNames } from '../../../constants';

export interface Props {
  errorName: ErrorNames;
}

const EmptyResultError: FC<Props> = ({ errorName }) => {
  return (
    <Trans
      i18nKey={`searchPage.emptyState.error.${errorName}`}
      components={{
        settingsLink: (
          <a
            className="text-link-level-1-brand"
            href={Url.to(URLS.SETTINGS_BROWSING)}
          />
        ),
      }}
    />
  );
};
EmptyResultError.displayName = 'EmptyResultError';

export default EmptyResultError;
